import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StringService {

  constructor() { }

  truncate(name: string, maxLength = 25): string {
    return name.slice(0, maxLength) + (name.length > maxLength ? '...' : '');
  }
}
